<template>
     <el-dialog custom-class="ck-config-dialog-class"
      :top="top"
      :visible.sync="dialogVisible" 
      @close="close"
      width="1300px" 
      :before-close="close"
      :close-on-click-modal="false" 
      :show-close="false">   
        <div class="add-ck-item" slot="title">
            <span>{{title}}  -  {{formData.name}}</span>
            <el-button type="primary" size="mini" icon = "el-icon-plus" class="add-ck-item-btn" :disabled = "!canAdd" @click="addCKItem">添加CK</el-button>
        </div>
        <div class="ck-config-list">
            <div class="ck-config-item" v-for="(item,index) in ckData.ck_list" :key="index">
                <CKItem :form="item" :loading="ckData.loading" @sureItem="sure" :index = "index" @deleteItem="deleteItem"></CKItem>
            </div>
        </div>
       
        

        <div slot="footer" class="dialog-footer">
            <el-button class="dialog-btn" type="primary" size="mini" @click="close" >关 闭</el-button>
        </div>
    </el-dialog>
</template>
<script>
import CKItem from './ckItem.vue'
 export default {
    name: 'CKConfig',
    components:{
        CKItem
    },
    props:{
        dialogVisible:{
            type: Boolean,
            default: false,
        },
        loading:{
            type: Boolean,
            default: false,
        },
        title:{
            type: String,
            default: '',
        },
        top:{
            type: String,
            default: '5vh',
        },
        form:{
            type: Object,            
            required:true,
            default:{},            
        }  

    },
       data(){        
           
        return {
            rules:{
                ck_value:[
                        { required: true, message: '请输入Cookie值', trigger: 'blur' },
                        //至少3个字符   
                        { min: 3, message: '长度至少3个字符', trigger: 'blur' },
                        
                    ],
                    ck_status:[
                        { required: true, message: '请选择状态', trigger: 'blur' },
                    ],
            },
            formData:{},
            ckData:{
                loading:false,
                ck_list:[],
                empty_ck_obj:{
                    ck_value:'',
                    ck_status:1,
                    ck_valid:3,
                },
                ck_valid_data:{
                    ck_valid:3,
                    ck_valid_text:'未检测',
                },
            }
        }
    },
    mounted() { 
        for (const key in this.form) {
            if(key !== 'loading'){
                this.$set(this.formData, key, this.form[key]);
            }
            
        }
        this.getCkConfig()
    },
    computed:{
        canAdd(){
            let can = true;
            for(let i = 0;i<this.ckData.ck_list.length;i++){
                if(!this.ckData.ck_list[i].id){
                    can = false
                }
            }
            return can
        }  
    },

    methods: {     
        getCkConfig(){
            this.$api.getCkConfig({traderId:this.form.id}).then(res=>{
                if(res.status == 1){
                    // let data = res.data
                    if(res.data.ck_list.length == 0){
                        this.ckData.ck_list.push( this.ckData.empty_ck_obj)
                    }else{
                        this.ckData.ck_list = res.data.ck_list
                    }
                    
                }else{
                    this.$message.error(res.msg)
                }
            })
        },
        close(){            
            this.$emit("close");
        },
        sure(param){ 
            let data = {
                traderId:this.form.id,
                ...param
                }
            this.$emit("sure",data)
        },
        //添加ck
        addCKItem(){            
            this.ckData.ck_list.push( this.ckData.empty_ck_obj)
        },
        deleteItem(param,index){
            this.$confirm('确认删除此数据吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if(param.id){
                    this.deleteCkConfig(param.id)
                }else{
                    this.ckData.ck_list.splice(index,1)
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
            
          
        },
        // 接口删除配置
        deleteCkConfig(id){
            this.$api.deleteCkConfig({ck_id:id}).then(res=>{
                if(res.status == 1){
                    this.$message.success(res.msg)
                    this.getCkConfig()
                }else{
                    this.$message.error(res.msg)
                }
            })
        }
        
    }

 }
</script>
<style lang="scss">
.ck-config-dialog-class{
    max-height:90vh;
}
</style>
<style lang="scss" scoped>

    .add-ck-item{
        // margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        height: 30px;
    }
    .ck-config-list{
        max-height: calc(90vh - 180px);
        overflow: auto;
    }
    .ck-config-item{
        display: flex;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
        padding: 10px;
        margin-bottom: 10px;
        border-radius: 5px;
    }
</style>